import React from "react";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import LineItems2 from "./LineItems2";
import ContactDetails from "./ContactDetails";
import withData from "./withData";
import HeaderData from "./HeaderData";

import CurrencyConversion from "./CurrencyConversion";

const excludeField = (obj, TaxNumber) => {
  const newObj = { ...obj };
  delete newObj[TaxNumber];
  return newObj;
};

const includeField = (obj, fieldName) => {
  return { [fieldName]: obj[fieldName] };
};

export const SimpleSmallDocument = ({
  item,
  contact,
  settings,
  organisation,
  taxRates,
  t,
  qrCode,
  ...props
}) => {

  const contactName = includeField(contact, 'Name')

  const organisationWithoutTax = excludeField(organisation, 'TaxNumber');

  return (

    <DocumentRenderer {...props}>
      <div className="sm-inv m-0 p-0 text-left" style={{ fontSize: "18px", maxWidth: "302px", float: "left" }}>
        {settings.logo && (
          <div className="my-4">
            <img style={{ maxHeight: 150, padding: "10px" }} src={settings.logo} alt="logo" />
          </div>
        )}
        <div>
          <h1 className="text-center" style={{ fontSize: "20px", fontWeight: "bold" }}>
            <Trans>{settings.invoice_label}</Trans>
          </h1>
        </div>
        <div className="header row" style={{ fontSize: "15px" }}>
          <div className="col-4">
            {qrCode && (
              <div className="qr-code">
                <img
                  alt="QR code"
                  src={qrCode}
                  style={{ width: "110px", height: "110px" }}
                  className="mb-4"
                />
              </div>
            )}
          </div>
          <div className="col-8">
            <div className="row">
              <div className="col-6">
                <div className="inv-el my-2">
                  <div className="inv-title font-weight-bold"><Trans>Invoice Number</Trans></div>
                  <div className="">{item.HesaabNumber || item.InvoiceNumber}</div>
                </div>
              </div>
              <div className="col-6">
                <div className="inv-el my-2">
                  <div className="inv-title font-weight-bold"><Trans>Invoice Date</Trans></div>
                  <div className="">{item.DateString} {item.Date.split('T')[1]}</div>
                </div>
              </div>
            </div>
            <div className="row my-2">
              <div className="col-6">
                <div className="inv-el my-2">
                  <div className="inv-title font-weight-bold"><Trans>Status</Trans></div>
                  <div className="">{t(item.Status)}</div>
                </div>
              </div>
              <div className="col-6">
                <div className="inv-el my-2">
                    <div className="inv-title font-weight-bold"><Trans>Invoice Due Date</Trans></div>
                    <div className="">{item.DueDateString} {item.Date.split('T')[1]}</div>
                </div>
              </div>  
            </div>
            <div className="row my-2">
              <div className="col-6">
                <div className="inv-el my-2">
                  <div className="inv-title font-weight-bold"><Trans>Reference</Trans></div>
                  <div className="">{item.Reference}</div>
                </div>
              </div>
              <div className="col-6">
                <div className="inv-el my-2">
                  <div className="inv-title font-weight-bold"><Trans>Supply Date</Trans></div>
                  <div className="">{item.ExpectedPaymentDateString}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-bottom2 my-2"></div>
        <div className="orgs-details c-text-start" style={{ fontSize: "14px" }}>
          <div className="row">
            <div className="col-6">
              <h5><Trans>Issuer</Trans></h5>
              <ContactDetails t={t} contact={organisation} />
                  {organisation.TaxNumber &&
                    <div>
                      <p className="my-0 py-0"><Trans>VAT</Trans>: {organisation.TaxNumber}</p>
                    </div>
                  }
                  {organisation.RegistrationNumber &&
                    <div>
                      <p className="my-0 py-0"><Trans>CRN</Trans>: {organisation.RegistrationNumber}</p>
                    </div>
                    
              }
              {/* <ContactDetails t={t} contact={organisation} /> */}
            </div>
            <div className="col-6">
              <h5><Trans>Client</Trans></h5>
              <ContactDetails t={t} contact={contactName} />
            </div>
          </div>
        </div>
        <div className="border-bottom2 my-2"></div>
        <div className="my-4">
          <div className="mb-4">
            <LineItems2 invoice={item} taxRates={taxRates} includeDiscount />
          </div>
        </div>

        <div className="border-bottom2 my-2"></div>
        <div className="inv-footer mx-auto text-center">
          <CurrencyConversion item={item} organisation={organisation} />
          <div className="font-weight-bold mt-3 mb-2">
            <Trans>Due Date: </Trans> {item.DueDateString}
          </div>
          {settings.footer ? (
            <div style={{ whiteSpace: "pre-line" }} className="mt-1">
              {settings.footer}
            </div>
          ) : null}
          {settings.footer_english ? (
            <div style={{ whiteSpace: "pre-line" }} className="mt-1 ltr" dir="ltr">
              {settings.footer_english}
            </div>
          ) : null}
        </div>


      </div>
    </DocumentRenderer>
  )
};

const TableRow = ({ label, value, isBold }) => (
  <tr>
    <td className={`text-start ${isBold ? 'font-weight-bold' : ''}`}>
      {label}
    </td>
    <td className="text-right" >{value}</td>
  </tr>
);


export default withData(SimpleSmallDocument);
